var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlagAuto = function SvgFlagAuto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.5c.35 2.85 1.65 5.15 4.5 6.5-2.85 1.35-4.15 3.65-4.5 6.5-.35-2.85-1.65-5.15-4.5-6.5 2.85-1.35 4.15-3.65 4.5-6.5zM18.2 14.2c.18 1.35.78 2.4 2.1 3.05-1.32.65-1.92 1.7-2.1 3.05-.18-1.35-.78-2.4-2.1-3.05 1.32-.65 1.92-1.7 2.1-3.05z"
  })));
};
export default SvgFlagAuto;